import React from 'react';
import Input from '../../../../../../components/Input';
import PhoneInput from "../../../../../../components/PhoneInput";
import Handedness from "../../../../../../components/Handedness";
import {FormikProps} from "formik";
import {registerUserPayloadType} from "../../../../../../types";
import DateTimePicker from "../../../../../../components/DateTimePicker/DateTimePicker";
import {getFieldError} from "../../../../../../utils";
import {isFullSwing} from "../../../../../../constants";
import MainStyle from "../../../../../../../MainStyle";
import {TextInput, HelperText} from "react-native-paper";
import Dropdown from "../../../../../../components/Dropdown";
import {Gender} from "../../../../../../../generated/smg_service_pb";
import {View} from "react-native";
import Svg, {Path} from "react-native-svg";
import Div from 'lib/Div';

const ErrorIcon = () => (
  <Svg width="20" height="20" viewBox="0 0 20 20" fill="none">
    <Path
      d="M18.0729 9.75C18.0729 14.2096 14.4271 17.8229 10 17.8229C5.54036 17.8229 1.92708 14.2096 1.92708 9.75C1.92708 5.32292 5.54036 1.67708 10 1.67708C14.4271 1.67708 18.0729 5.32292 18.0729 9.75ZM10 11.3776C9.15365 11.3776 8.5026 12.0612 8.5026 12.875C8.5026 13.7214 9.15365 14.3724 10 14.3724C10.8138 14.3724 11.4974 13.7214 11.4974 12.875C11.4974 12.0612 10.8138 11.3776 10 11.3776ZM8.56771 6.00651L8.79557 10.4336C8.82813 10.6615 8.99089 10.7917 9.1862 10.7917H10.7812C10.9766 10.7917 11.1393 10.6615 11.1719 10.4336L11.3997 6.00651C11.4323 5.77865 11.237 5.58333 11.0091 5.58333H8.95833C8.73047 5.58333 8.53516 5.77865 8.56771 6.00651Z"
      fill="#F56E6E"
    />
  </Svg>
);

type EmailProps = { formik: FormikProps<registerUserPayloadType> };
export const Email = (props: EmailProps) => {
  const {formik} = props;

  return (
    <>
      {isFullSwing ? (
        <Div mb={20}>
          <TextInput
            label="Email" onBlur={formik.handleBlur('email')}
            style={[MainStyle.b_r_4, !!getFieldError('email', formik) && {borderWidth: 1, borderColor: '#F56E6E'}]}
            value={formik.values.email} error={!!getFieldError('email', formik)} keyboardType="email-address"
            onChangeText={text => formik.setFieldValue('email', text)} underlineColor="transparent"
          />
          {!!getFieldError('email', formik) && (
            <View style={{flexDirection: 'row', alignItems: 'center', marginTop: 4}}>
              <ErrorIcon/>
              <HelperText type="error" visible={true} style={{margin: 0, padding: 0, paddingLeft: 4}} padding='none'>
                {getFieldError('email', formik) as string}
              </HelperText>
            </View>
          )}
        </Div>
      ) : (
        <Input
          placeholder="Enter Text Here" type="email-address" label="EMAIL ADDRESS *" value={formik.values.email}
          onChangeText={formik.handleChange('email')} onBlur={formik.handleBlur('email')}
          error={getFieldError('email', formik)} onFocusScroll
        />
      )}
    </>
  );
};

type PhoneProps = { formik: FormikProps<registerUserPayloadType> };
export const Phone = (props: PhoneProps) => {
  const {formik} = props;

  return (
    <PhoneInput
      w="100%" placeholder="Phone Number" label={isFullSwing ? undefined : 'PHONE NUMBER - MOBILE *'}
      value={formik.values.phone} onChangeText={formik.handleChange('phone')}
      onBlur={formik.handleBlur('phone')} error={getFieldError('phone', formik)} h={isFullSwing ? 56 : undefined}
      bg={isFullSwing ? '#252526' : undefined} rounded={isFullSwing ? 4 : undefined} fs={isFullSwing ? 16 : undefined}
    />
  );
};

type NameProps = { formik: FormikProps<registerUserPayloadType> };
export const Name = (props: NameProps) => {
  const {formik} = props;

  return (
    <>
      {isFullSwing ? (
        <>
          <Div mb={15}>
            <TextInput
              label="Screen Name" onBlur={formik.handleBlur('username')}
              style={[MainStyle.b_r_4, !!getFieldError('username', formik) && {borderWidth: 1, borderColor: '#F56E6E'}]}
              value={formik.values.username} error={!!getFieldError('username', formik)}
              onChangeText={text => formik.setFieldValue('username', text)} underlineColor="transparent"
            />
            {!!getFieldError('username', formik) && (
              <View style={{flexDirection: 'row', alignItems: 'center', marginTop: 4}}>
                <ErrorIcon/>
                <HelperText type="error" visible={true} style={{margin: 0, padding: 0, paddingLeft: 4}} padding='none'>
                  {getFieldError('username', formik) as string}
                </HelperText>
              </View>
            )}
          </Div>

          <Div mb={15}>
            <View
              style={[!!getFieldError('gender', formik) && {borderWidth: 1, borderColor: '#F56E6E', borderRadius: 4}]}>
              <Dropdown
                formik={formik} field="gender" label="Gender"
                items={[{value: Gender.MALE, label: 'Male'}, {value: Gender.FEMALE, label: 'Female'}]}
              />
            </View>
            {!!getFieldError('gender', formik) && (
              <View style={{flexDirection: 'row', alignItems: 'center', marginTop: 4}}>
                <ErrorIcon/>
                <HelperText type="error" visible={true} style={{margin: 0, padding: 0, paddingLeft: 4}} padding='none'>
                  {getFieldError('gender', formik) as string}
                </HelperText>
              </View>
            )}
          </Div>
        </>
      ) : (
        <>
          <Input
            placeholder="Enter Text Here" label="PLAYER NAME (FOR SCREEN)" value={formik.values.username}
            onChangeText={formik.handleChange('username')} onBlur={formik.handleBlur('username')}
            error={getFieldError('username', formik)} onFocusScroll mb={15} textAlign="center"
          />

          <Input
            placeholder="Enter Text Here" label="FIRST NAME"
            value={formik.values.firstname} onChangeText={formik.handleChange('firstname')}
            onBlur={formik.handleBlur('firstname')} error={getFieldError('firstname', formik)}
            onFocusScroll mb={15} textAlign="center"
          />

          <Input
            placeholder="Enter Text Here" label="LAST NAME" value={formik.values.lastname}
            onChangeText={formik.handleChange('lastname')} onBlur={formik.handleBlur('lastname')}
            error={getFieldError('lastname', formik)} onFocusScroll mb={15} textAlign="center"
          />
        </>
      )}

      <Div mb={15}>
        <View style={[
          !!getFieldError('dateOfBirth', formik) && {borderWidth: 1, borderColor: '#F56E6E', borderRadius: 4}
        ]}>
          <DateTimePicker
            formik={formik} label={isFullSwing ? undefined : 'DATE OF BIRTH'} h={isFullSwing ? '56px' : undefined}
            bg={isFullSwing ? '#252526' : undefined} rounded={isFullSwing ? '4px' : undefined}
            textAlign={isFullSwing ? 'left' : 'center'} placeholder={isFullSwing ? 'Date of Birth' : undefined}
            fs={isFullSwing ? '16px' : undefined} variant={isFullSwing ? 'filled' : 'outlined'}
          />
        </View>
        {!!getFieldError('dateOfBirth', formik) && (
          <View style={{flexDirection: 'row', alignItems: 'center', marginTop: 4}}>
            <ErrorIcon/>
            <HelperText type="error" visible={true} style={{margin: 0, padding: 0, paddingLeft: 4}} padding='none'>
              {getFieldError('dateOfBirth', formik) as string}
            </HelperText>
          </View>
        )}
      </Div>

      {!isFullSwing && (
        <Handedness
          error={getFieldError('handedness', formik)} value={formik.values.handedness}
          onChange={val => formik.setFieldValue('handedness', val)} mb={12}
        />
      )}
    </>
  );
};
